export const isDefaultHirerName = (firstName?: string, lastName?: string) => {
    if (!firstName || !lastName) {
        return false;
    }
    return /^(obe|web)$/.test(firstName.toLowerCase()) && lastName.toLowerCase() === 'enquiry';
};
